import { Component, OnInit, Input } from '@angular/core';
import { PopupService } from '../../../services/shared/popup.service';
import { VehicleMakeService } from '../../../services/vehicle-make.service';
import { VehicleTypeService } from '../../../services/vehicle-type.service';
import { VehicleService } from '../../../services/vehicle.service';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PermitService } from 'app/services/permit.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'vehicle-viewer',
  templateUrl: './vehicle-viewer.component.html',
  styleUrls: ['./vehicle-viewer.component.css']
})
export class VehicleViewerComponent implements OnInit {
  @Input('ctrlData') ctrlData: any;

  vehicle: any = {};
  listvehicles: any = [];
  list_vehicle_type: any = [];
  list_vehicle_make: any = [];
  editMode: boolean = false;
  disableAdd: boolean = false;
  max_pass:number = 10000;
  min_pass:number = 0;
  haserror:boolean=false;
  gridload:boolean=false;
  tabload:boolean =false;
  public pageload = false;

  constructor(private showModal:PopupService, private vehicleTypeService: VehicleTypeService, private vehicleMakeService: VehicleMakeService,
    private vehicleService:VehicleService, private toastr:ToastrService, private toastService:ToastNotificationService,
    private applicationService:ApplicationService,
    public utility: UtilityServiceService,
    private router:Router,private permitService:PermitService,private activeRoute: ActivatedRoute) { }

 
    ngOnInit() {
      //get the vehicles with this application
      /* if(this.listvehicles.length > 0){
        this.ctrlData.formValid = true; 
      }
      if(this.ctrlData.vehicles.length > 0)
      {
        this.listvehicles.push(this.listvehicles);
      } */
      //console.log("Current data");
      //console.log(this.ctrlData);
      //console.log("end Current data");
     // 
      this.getVehicleType();
      this.getVehicleMake();
      this.setVehicles();
      this.getApplication();
     // if(this.ctrlData.isViewEditControl == true){
       // this.editMode = this.dataCntrl.editMode;
      //  this.setVehicles();
     // }
     // //console.log(this.ctrlData.vehicles);

     //this.getApplication();
      /* if(this.router.url.indexOf('edit') > 0){
        this.activeRoute.params.subscribe((params: Params) => {
          this.ctrlData.application.id=  params['id'];
        });
        
      } */
  
    }
    getApplication(){
      this.pageload = true;
  
      if(this.ctrlData.data.id !== null && this.ctrlData.data.id !== undefined){
        this.applicationService.getById(this.ctrlData.data.id).subscribe((data:any) =>{
          //console.log("vehicles");
          //console.log(data.vehicle);
          //console.log("end vehicles");
          this.pageload = false;
  
          for(let i =0; i<data.vehicle.length;i++){
            let object = {
              id: data.vehicle[i].id,
              vehicle_type_id: data.vehicle[i].vehicle_type_id,
              vehicle_make_id: data.vehicle[i].vehicle_make_id,
              vehicle_make: data.vehicle[i].vehicle_make,
              vehicle_type:data.vehicle[i].vehicle_type,
              is_current: false,
              registration_number: data.vehicle[i].registration_number,
              seating_capacity: data.vehicle[i].seating_capacity,
              // number_passengers: data.vehicle[i].number_passengers,
              gvn: data.vehicle[i].gvn,
              vin: data.vehicle[i].vin,
              date_license_expiry:data.vehicle[i].date_license_expiry,
              editMode:false
            }
           /*  if(this.listvehicles.length === data.vehicle.length){
              //console.log('Its 0')
              this.pageload = false;
              //this.dataCntrl.vehicles = this.listvehicles;
              return;
            }  */
            //console.log(object);
            
            this.listvehicles.push(object);
  
           
  
                
            
          }
          //console.log(this.vehicle);
  
          
          
          this.ctrlData.vehicle = this.listvehicles;
        
        })
      }
      
    }

    getVehicleType() {
      if(this.list_vehicle_type.length <= 0)
      this.vehicleTypeService.getAll().subscribe(result => {
        this.list_vehicle_type = result;
      }, error => {
        //console.log(error);
      });
    }
  
     getVehicleMake() {
      if(this.list_vehicle_make.length <= 0)
      this.vehicleMakeService.getAll().subscribe(result => {
        this.list_vehicle_make = result;
      }, error => {
        //console.log(error);
      });
    }
  
    setVehicles(){

      //this.listvehicles = this.ctrlData.vehicle;
     /*  for(let list of this.listvehicles){
        {
          list.editMode=false;
        }
      } */
    }
    onVehicleTypeSelected(index){
      if(this.haserror){
        this.haserror = false;
      }
      let id = this.listvehicles[index].vehicle_type_id;
      var obj = this.list_vehicle_type.find(p=>p.id == id);
      this.listvehicles[index].vehicle_type = obj.description;
      this.max_pass = obj.passengers_max ? obj.passengers_max : 10000 ;
      this.min_pass = obj.passengers_min ? obj.passengers_min : 0;
    }

    onVehicleMakeSelected(index){
      if(this.haserror===true){
        this.haserror = false;
      }
      let id = this.listvehicles[index].vehicle_make_id;
      var obj = this.list_vehicle_make.find(p=>p.id == id);
      this.listvehicles[index].vehicle_make = obj.description;
    }
    addNew(){
      this.vehicle = {id:-1, vehicle_type_id:-1, vehicle_type: '', vehicle_make_id:-1, vehicle_make: '', is_current: false, registration_number:'', seating_capacity:'', number_passengers:'', gvn:'', vin:'',permit_id : this.ctrlData.permit.id, editMode:true};
      this.editMode = true;
      if(this.editMode){
        this.listvehicles.push(this.vehicle);
      }else{
        this.disableAdd = true;
      }
    }

    confirmVehicleDelete(item){
      this.showModal.showConfirm('Delete Vehicle', 'Are you sure you want to delete?', `You're about to delete a vehicle with registration: ${item.registration_number}`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.deleteVehicle(item);
          if(item.id > 0){
            this.vehicleService.removeVehicle(item.id).subscribe(x =>{
              //console.log(x);
            })
          }
          
        } else {
          return;
        }
      });
    }

    deleteVehicle(item){
      const index: number = this.listvehicles.indexOf(item);
        if (index !== -1) {
            this.listvehicles.splice(index, 1);
        }
  
        if(this.listvehicles.length <= 0){
          this.ctrlData.formValid = false;
        }
    }

    editVehicle(item){
      const index: number = this.listvehicles.indexOf(item);
      if (index !== -1) {
          this.listvehicles[index].editMode = true;
      }
    }
    saveVehicle(item){
      //console.log(item);
      //console.log(this.ctrlData.vehicles)
  
      let object = {
        id: item.id,
        vehicle_type_id: item.vehicle_type_id,
        vehicle_type: item.vehicle_type,
        vehicle_make_id: item.vehicle_make_id,
        vehicle_make: item.vehicle_make,
        is_current: false,
        registration_number: item.registration_number,
        seating_capacity: item.seating_capacity,
        // number_passengers: item.number_passengers,
        gvn: item.gvn,
        vin: item.vin,
        permit_id : this.ctrlData.permit.id,
        date_modified : new Date(),
        date_created : new Date(),
        user_modified : item.user_created = environment.authWebApi.userData.User.FirstName,
        editMode:true
      }
      
      if(item.vehicle_type_id ==-1 || item.vehicle_make_id == -1){
        this.haserror = true;
        this.showModal.showAlert('Save Vehicle','<p>Please&nbsp;make&nbsp;sure&nbsp;you&nbsp;captured&nbsp;the&nbsp;below&nbsp;fields:</p><ul><li>Vehicle&nbsp;Type</li><li>Vehicle&nbsp;Make</li></ul><p><em><small><span style="font-size:11.0pt"><span style="font-family:&quot;Calibri&quot;,sans-serif">NB: If you do not yet have a vehicle, you must select the Type you plan to use. Then choose &lsquo;Undecided&rsquo; as the Make if you do not have a specific vehicle in mind.</span></span></small></em></p>');
      }else{
        this.ctrlData.vehicles = [];
        if(item.id == -1){
          this.haserror = false;
          item.editMode = false;
          this.disableAdd = false;
          this.ctrlData.formValid = true;
          const index: number = this.listvehicles.indexOf(item);
          this.listvehicles[index] = item;
  
          //save vehicle
          this.pageload = true;
          this.vehicleService.updateVehicle(object).subscribe(result => {
            this.pageload = false;
         // this.dataCntrl.vehicles = result;
          this.tabload = false;
      this.toastService.success('Saved Vehicle Successfully','Vehicle');
        //  this.updateVehiclelist(result);
          },
          error => {
            this.pageload = false;
            this.tabload = false;
          // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
              this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Vehicle');
  
          return;
          });
  
        }else{
          //console.log('HERE')
          
          //console.log(object);
  
          this.haserror = false;
          item.editMode = false;
          this.disableAdd = false;
          this.ctrlData.formValid = true;
          this.listvehicles.push(object)
          const index: number = this.listvehicles.indexOf(item);
          if (index !== -1) {
              this.listvehicles.splice(index, 1);
          }
          //save vehicle
          this.pageload = true;
          this.vehicleService.updateVehicle(object).subscribe(result => {
            this.pageload = false;
          // this.dataCntrl.vehicles = result;
          this.tabload = false;
      this.toastService.success('Saved Vehicle Successfully','Vehicle');
        //  this.updateVehiclelist(result);
          },
          error => {
            this.pageload = false;
            this.tabload = false;
          // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
              this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Vehicle');
  
          return;
          });
  
  
        }
        this.ctrlData.vehicles = this.listvehicles;
      }
    }

    cancelVehicle(item){
      if(item.id==-1){
        const index: number = this.listvehicles.indexOf(item);
        if (index !== -1) {
            this.listvehicles.splice(index, 1);
        }
        this.disableAdd = false;
      }else{
        item.editMode = false;
        this.disableAdd = false;
      }
    }

    saveVehicles(){
      this.tabload = true;
      this.pageload = true;
      //console.log(this.ctrlData.vehicles);
      if(this.ctrlData.application.id !== null && this.ctrlData.application.id !== undefined){
        return this.applicationService.setTab(3);
      }
      this.ctrlData.vehicles.forEach(element => {
        element.permit_id = this.ctrlData.permit.id;
        element.date_modified = element.date_created = new Date();
        element.user_modified = element.user_created = environment.authWebApi.userData.User.Username;
      });
        if(this.ctrlData.application.id == undefined){
         //this.saveApplication();
         this.pageload = false;
         this.toastService.error('Please select permit type first','Vehicle');
  
        }else{
          this.pageload = false;
  
          this.applicationService.setTab(3);
     
        }
    }

    UpdateVehicle(){
      this.ctrlData.vehicles.forEach(element => {
        element.permit_id = this.ctrlData.permit.id;
        element.date_modified = element.date_created = new Date();
        element.user_modified = element.user_created = environment.authWebApi.userData.User.Username;
      });
      this.vehicleService.updateVehicle(this.ctrlData.vehicles).subscribe(result => {
        this.pageload = false;
        this.ctrlData.vehicles = result;
        this.tabload = false;
        this.toastService.success('Saved Vehicle Successfully','Vehicle');
      // this.updateVehiclelist(result);
       //this.getApplication();
  
      },
      error => {
        this.pageload = false;
        this.tabload = false;
      // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
          this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Vehicle');
  
      return;
      })
    }

    updateVehiclelist(data){
      this.setVehicles();
      this.applicationService.setTab(3);
      this.utility.confirmCtrl = true;
    }
    backtoPermit(){
      this.applicationService.setTab(1);
    }
    cancelApplication(){
      if(this.ctrlData.application.id==undefined && this.ctrlData.application.id==null){
        this.router.navigate(['/carrier/permit/application/'+this.ctrlData.carrierID]);
      }else{
        this.showModal.showConfirm('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
        .subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.deleteApplication()
          } else {
            return;
          }
        });
      }
    }
    deleteApplication(){
      //console.log("delete application");
      this.pageload = true;
  
      this.permitService.deletePermit(this.ctrlData.permit.id).subscribe(x =>{
        //console.log(x);
      this.deleteApp(this.ctrlData.application.id);
      this.pageload = false;
  
      this.router.navigate(['/carrier/permit/application/'+this.ctrlData.carrierID]);
  
      })
 
    }
    deletePermit(id){
      this.permitService.deletePermit(id).subscribe(x =>{
        //console.log(x);
      })
  
    }
    deleteApp(id){
      this.applicationService.deleteApplication(id).subscribe(x =>{
        //console.log(x);
      })
    }

}
